import {
  KeyboardArrowDown,
  KeyboardArrowUp
} from '@mui/icons-material';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@mui/material';
import { MessageDataValue } from 'generated/graphql';
import _ from 'lodash';
import { dataUtil } from 'modules';
import {
  useMemo,
  useState
} from 'react';



export type SegmentedTableRowProps = {
  glAccountName: string;
  data: MessageDataValue[];
  label: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SegmentedTableRowProps) => {
  const [
    expanded,
    setExpanded
  ] = useState(false);

  const annualData = props.data.filter((d) => d.period === 'fy');

  const mostRecentDataPoint = _.last(annualData);

  const period2Data = useMemo(() => {
    return _.groupBy(annualData, (d) => d.year);
  }, [annualData]);


  const collapsedTableRows = useMemo(() => {
    const periodToRows = _.mapValues(period2Data, (val, k) => {
      return (
        <TableRow key={k}>
          <TableCell sx={{
            textAlign: 'left',
            paddingLeft: '4rem'
          }}
          >
            {k.toUpperCase()}
          </TableCell>

          <TableCell
            sx={{
              textAlign: 'left',
              paddingLeft: '8rem',
              fontStyle: 'italic'
            }}
          >
            {_.last(val.map((v) => __formatDataPoint(v)))}
          </TableCell>
        </TableRow>
      );
    });

    return _.values(periodToRows);
  }, [period2Data]);

  return (
    <>
      <TableRow>
        <TableCell sx={{
          textAlign: 'left',
          width: '25%'
        }}
        >
          <IconButton
            size='small'
            onClick={() => setExpanded((prev) => !prev)}
          >
            {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>

          {props.label}
        </TableCell>

        <TableCell sx={{
          textAlign: 'left'
        }}
        >
          {mostRecentDataPoint ? __formatDataPoint(mostRecentDataPoint) : 'N/A'}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell sx={{
          textAlign: 'left'
        }}
        >
          <Collapse in={expanded}>
            <Table size='small'>
              <TableBody>
                {collapsedTableRows}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};



function __formatDataPoint(dataPoint: MessageDataValue) {
  const value = _.toNumber(dataPoint.value);
  if (dataPoint.unit === 'usd') {
    return '$' + value.toLocaleString('en-US');
  }

  if (dataPoint.unit === 'percentage') {
    return (value * 100).toFixed(2) + '%';
  }

  return dataUtil.formatWithComma(value) + ' ' + dataPoint.unit;

}
